
import { useTheme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import EDTypography from '../../BaseComponents/Typography/EDTypography';
import { IBusinessColorConfig } from '../../Features/Delsystem/_Common/Const/BusinessConfigs';

export interface ILegendProps {
  posts: ILegendPost[];
}

export interface ILegendPost extends IBusinessColorConfig {
  dual?: boolean;
}

const useStyles = makeStyles()(
  theme =>
    ({
      container: {
        padding: 24,
      },
      flexContainer: {
        display: 'flex',
      },
      flexContainerPadding: {
        paddingBottom: 16,
      },
      box: {
        borderRadius: 4,
        width: 19,
        minWidth: 19,
        height: 19,
        marginRight: 8,
      },
      singleBox: {
        [theme.breakpoints.up('lg')]: {
          marginRight: 36,
        },
      },
    } as const)
);

const Legend: React.FC<React.PropsWithChildren<ILegendProps>> = props => {
  const { classes, cx } = useStyles();
  const theme = useTheme();
  return (
    <div className={classes.container}>
      {props.posts.map((post, index) => (
        <div
          className={cx(classes.flexContainer, {
            [classes.flexContainerPadding]: index < props.posts.length - 1,
          })}
          key={index}
        >
          <div
            className={cx(classes.box, {
              [classes.singleBox]: !post.dual,
            })}
            style={{
              background:
                post.striped || post.greyBox
                  ? 'white'
                  : theme.customProperties.Legend[post.color ?? 'gray'][
                      post.colorOpacity ?? 'full'
                    ],
              border: post.striped
                ? '1px solid white'
                : `1px solid ${
                    theme.customProperties.Legend[post.color ?? 'gray'][
                      post.colorOpacity ?? 'full'
                    ]
                  }`,
              ...(post.striped && {
                backgroundImage:
                  'repeating-linear-gradient(45deg, transparent, transparent 3px, rgba(160, 158, 158, 0.8) 3px, rgba(160, 158, 158, 0.8) 6px)',
              }),
            }}
          />
          {post.dual && (
            <div
              className={classes.box}
              style={{
                background:
                  theme.customProperties.Legend[post.color ?? 'gray'][
                    post.colorOpacity ?? 'full'
                  ],
                border: `1px solid ${
                  theme.customProperties.Legend[post.color ?? 'gray'][
                    post.colorOpacity ?? 'full'
                  ]
                }`,
              }}
            />
          )}
          <EDTypography bold>{post.caption}</EDTypography>
        </div>
      ))}
    </div>
  );
};

export default Legend;
